<template>

  <Button :label="$t('library.cycle.edit_button')" 
    class="p-button-outlined" icon="icon-edit" iconPos="left" 
    @click="buttonClick" />

</template>

<script>
import RecipeService from '../../../service/RecipeService';
import { mapGetters } from 'vuex';

export default {

  components: {
    },
    props: {
      serialNumber: String,
      recipe: Object,
      appliance: Object
    },
    data() {
        return {
          dialog: {
            error: false,
          },
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
        }),
    },
    watch: {
    },
    created() {
      this.recipeService = new RecipeService();
    },
    mounted() {
    },
    methods: {
      buttonClick() {
        if(this.serialNumber) {
          this.$router.push({ name: 'appliance-recipe-edit', params: { serialNumber: this.serialNumber, recipeId: this.recipe.id } })
        } else {
          this.$router.push({ name: 'recipe-edit', params: { recipeId: this.recipe.id } })
        }
      }
    }

}
</script>

<style scoped>

</style>